import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { DataModalProps } from '@/types';
import {
  ModalSliceTermsOfServicePrimary,
  Simplify,
} from '../../../../../prismicio-types';
import { InstructionList, TermsServiceHeroInner } from '@/components';

import styles from './TermsOfServiceModal.module.scss';

type List =
  Simplify<Content.TermsInstrictionSliceDefaultPrimaryInstructionItem>[];

const instructionTitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => (
    <p className={styles.instructionTitle}>{children}</p>
  ),
};

export const TermsOfServiceModal: FC<
  DataModalProps<ModalSliceTermsOfServicePrimary>
> = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.hero}>
        <TermsServiceHeroInner
          data={{
            last_update_text: data.last_update_text,
            last_update_value: data.last_update_value,
            description: data.description,
            title: data.title,
          }}
          variant="modal"
        />
      </div>
      <div className={styles.lists}>
        <InstructionList
          list={data.numbered_list as List}
          variation="numbered"
        />
        <div className={styles.listBox}>
          <PrismicRichText
            field={data.instruction_title}
            components={instructionTitleComponents}
          />
          <InstructionList
            list={data.numbered_small_with_title_list as List}
            variation="numbered"
          />
        </div>
      </div>
    </div>
  );
};
